import Axios from 'axios'

export default {
  state: {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    sideNav: false,
    loading: false,
    error: null,
    snackAlert: { status: false, success: false, error: false, boldMessage: '', message: '' },
    validationAlert: false,
    firstLoginDialog: false,
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion
    },
    firstLoginDialog: (state) => {
      return state.firstLoginDialog
    },
    sideNav(state) {
      return state.sideNav
    },
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    },
    business(state) {
      return state.business
    },
    validationAlert(state) {
      return state.validationAlert
    },
    snackAlert(state) {
      return state.snackAlert
    }
  },
  mutations: {
    setSideNav(state) {
      state.sideNav = !state.sideNav
    },
    setFirstLoginDialog(state, payload) {
      state.firstLoginDialog = payload
    },
    setLoading(state) {
      state.loading = !state.loading
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
    setSnackAlert(state, payload) {
      state.snackAlert = payload
    },
    clearSnackAlert(state) {
      state.snackAlert = { status: false, success: false, error: false, boldMessage: '', message: '' }
    },
    setValidationAlert(state, payload) {
      state.validationAlert = payload
    },
    setMessageSuccess(state, payload) {
      state.clientMessageSuccess = payload
    },
    clearMessageSuccess(state) {
      state.clientMessageSuccess = null
    }
  },
  actions: {
    sideNavChanged({ commit }) {
      commit('setSideNav')
    },
    async onCloseFirstLoginDialog({ commit, dispatch, getters }, payload) {
      dispatch('updateUser', { ...getters.user, interestList: payload })
      commit('setFirstLoginDialog', false)
    },
    clearSnackAlert({ commit }) {
      commit('clearSnackAlert')
    },
    setSnackAlert({ commit }, payload) {
      commit('setSnackAlert', payload)
    },
    clearError({ commit }) {
      commit('clearError')
    },
    setError({ commit }, payload) {
      commit('setError', payload)
    },
    isValidateCoach({ commit, getters }) {
      if (getters.user.coach) {
        if (getters.user.coach.isValidate) {
          commit('setValidationAlert', false)
        }
      } else { commit('setValidationAlert', true) }
    },
    clearMessageSuccess({ commit }) {
      commit('clearMessageSuccess')
    }
  }
}
